import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import EntryIdsSnippetNotFoundError from './entry-ids-snippet-not-found-error';
import {entryIdsSnippetMap} from 'components/organisms/late-swap/services/maps';

const EntryIdsSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();

        try {
            return entryIdsSnippetMap[site]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new EntryIdsSnippetNotFoundError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default EntryIdsSnippetFactory;
